<template lang="html">
  <div>
    <empty v-if="hasErr" :text="text"></empty>
    <div class="main" ref="main" v-else>
      <component :is="moduleId" :info="enterInfo" :stepNo="stepNo"></component>
    </div>
  </div>
</template>
<script>
import { mapState, mapMutations } from 'vuex'
import empty from '@/components/common/empty'

export default {
  data() {
    return {
      uid: '',
      skey: '',
      puid: '',
      stepNo: 0,
      moduleId: '',
      shareInfo: {
        title: '快速入驻孩子王认证育儿师',
        desc: '让你轻松接单不烦恼，服务收益最大化，提前实现财务自由',
        link: 'https://life.cekid.com/v/entering/step0?refresh=no'
      },
      hasErr: false,
      text: ''
    }
  },
  async beforeCreate() {
    try {
      const { uid, skey } = await this.$$ensureLogin()
      this.uid = uid
      this.skey = skey
      const tkey = this.$route.query.hserecomkey || ''
      const managerUid = this.$route.query.puid || ''
      const json = await this.$store.dispatch('getEnterInfo', {
        uid,
        tkey,
        skey,
        managerUid
      })
      // console.log(json)
      if (json.code * 1 === 4) {
        this.$$login()
      } else if (json.code * 1 !== 1) {
        this.text = json.msg || '系统异常'
        this.hasErr = true
        this.$$loading(false)
      } else {
        const config = await this.$store.dispatch('getMainConfig')
        if (this.$route.query.own || '') {
          this.shareInfo = Object.assign(
            this.shareInfo,
            config.data.yuesaoShareInfo
          )
        } else {
          this.shareInfo = Object.assign(
            this.shareInfo,
            config.data.rewardShareInfo
          )
        }
        const arr = ['pre_step_one', 'pre_step_two', 'fail']
        this.stepNo = this.enterInfo.status - 0 || 0
        if (this.stepNo >= 1) {
          this.stepNo = 1
        }
        const params_stepNo = this.$route.params.stepNo - 0
        const reSign = this.$route.query.resign || false
        if (reSign && params_stepNo === 0) {
          this.stepNo = 0
        }
        // if (this.enterInfo.validate === 1) {
        //     this.stepNo = 2
        // }
        this.moduleId = arr[this.stepNo]
        const component = () =>
          import(`../../components/entering/${this.moduleId}`)
        const components = []
        components[this.moduleId] = component
        this.$options.components = components
        this.$$share(this.shareInfo)
      }
    } catch (e) {
      console.log(e)
      if (e.code === '4') {
        this.$$login()
      } else {
        this.$$toast(e.msg)
        this.firstFetch = false
        // this.$$toast('网络异常，请刷新重试')
        this.hasErr = true
      }
    }
  },
  methods: {},
  computed: {
    ...mapState(['enterInfo'])
  },
  components: {
    empty
  }
}
</script>

<style lang="scss" scoped>
.main {
  background-color: #f4f4f4;
}
</style>
